import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Toaster = () => {
  return (
    <ToastContainer position={'top-right'} hideProgressBar theme="colored" />
  );
};
